// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportingDetailsThemesPage_wrapper__udBDQ"};